import React, { Component } from 'react';
import { gsap } from 'gsap';
import { TextureCropper } from '../../../textureCropper';
import './style.css';

const URL_ADD = (url) => `/../images/ver2/snowman/clips/${url}.png`;
const STANDART_WIDTH = 144;
const STANDART_HEIGHT = 200;

const ALL_Y_FRAMES = 15;

const ANIMATIONS = {
    breath: { key: 'breath', frames: 5, x: 0, yShift: 0, width: STANDART_WIDTH },
    ginga: { key: 'ginga', frames: 14, x: 1, yShift: 0, width: STANDART_WIDTH },
    martelo: { key: 'martelo', frames: 10, x: 65, yShift: 1, width: STANDART_WIDTH },
    bencao: { key: 'bencao', frames: 10, x: 58, yShift: 2, width: STANDART_WIDTH },
    rasteira: { key: 'rasteira', frames: 10, x: 65, yShift: 3, width: STANDART_WIDTH },
    diagonale: { key: 'diagonale', frames: 8, x: 0, yShift: 4, width: STANDART_WIDTH },
    middle1: { key: 'middle1', frames: 8, x: 0, yShift: 5, width: STANDART_WIDTH },
    jump: { key: 'jump', frames: 8, x: 0, yShift: 6, width: STANDART_WIDTH },
    armada: { key: 'armada', frames: 10, x: 65, yShift: 7, width: STANDART_WIDTH },
    compassa: { key: 'compassa', frames: 11, x: 50, yShift: 8, width: STANDART_WIDTH },
    pulada: { key: 'pulada', frames: 11, x: 65, xLeft: 2, xRight: 7, yShift: 9, width: STANDART_WIDTH },
    parafuso: { key: 'parafuso', frames: 11, x: 60, xLeft: 3, xRight: 8, yShift: 10, width: STANDART_WIDTH },
    beduin: { key: 'beduin', frames: 8, x: 0, yShift: 11, width: STANDART_WIDTH },
    salto: { key: 'salto', frames: 8, x: 0, yShift: 12, width: STANDART_WIDTH },
    boche: { key: 'boche', frames: 8, x: 0, yShift: 13, width: STANDART_WIDTH },
    goback: { key: 'goback', frames: 8, x: -30, yShift: 14, width: STANDART_WIDTH },

    combo2: {
        key: 'combo2', frames: 13, x: 60, xLeft: 3, xRight: 10, yShift: 9, width: STANDART_WIDTH,
        yShifts: [
            { innerFrame: 6, key: 'parafuso', frame: 3 }
        ],
    },
    combo3: {
        key: 'combo3', frames: 20, x: 60, xLeft: 3, xRight: 16, yShift: 9, width: STANDART_WIDTH,
        yShifts: [
            { innerFrame: 6, key: 'parafuso', frame: 3 },
            { innerFrame: 12, key: 'compassa', frame: 2 }
        ],
    },
    combo4: {
        key: 'combo1', frames: 20, x: 60, xLeft: 3, xRight: 16, yShift: 2, width: STANDART_WIDTH,
        yShifts: [
            { innerFrame: 6, key: 'rasteira', frame: 3 },
            { innerFrame: 12, key: 'compassa', frame: 2 }
        ],
    },
    combo1: {
        key: 'combo1', frames: 13, x: 60, xLeft: 3, xRight: 10, yShift: 2, width: STANDART_WIDTH,
        yShifts: [
            { innerFrame: 6, key: 'martelo', frame: 3 }
        ],
    },
}

// const ANIMATIONS = {
//     breath: { key: 'breath', src: URL_ADD('breath'), frames: 5, x: 0, width: STANDART_WIDTH },
//     ginga: { key: 'ginga', src: URL_ADD('ginga'), frames: 14, x: 1, width: STANDART_WIDTH },
//     martelo: { key: 'martelo', src: URL_ADD('martelo'), frames: 10, x: 65, width: STANDART_WIDTH },
//     bencao: { key: 'bencao', src: URL_ADD('bencao'), frames: 10, x: 58, width: STANDART_WIDTH },
//     rasteira: { key: 'rasteira', src: URL_ADD('rasteira'), frames: 10, x: 65, width: STANDART_WIDTH },
//     diagonale: { key: 'diagonale', src: URL_ADD('diagonale'), frames: 8, x: 0, width: STANDART_WIDTH },
//     middle1: { key: 'middle1', src: URL_ADD('middle1'), frames: 8, x: 0, width: STANDART_WIDTH },
//     jump: { key: 'jump', src: URL_ADD('jump'), frames: 8, x: 0, width: STANDART_WIDTH }
// }


export default class NgGameRPGChar extends Component {

    state = {
        animations: [],
        animationDefault: 'breath',
        frameRate: 55,
        gingaFrameRate: 220,
        intervalKey: 1,

        frameX: 0,
        frameY: 0,
        shiftX: 0
    }

    ttRef = React.createRef();

    lastDate = new Date();
    mainTimer = null;

    componentDidMount() {

        const { settings = {} } = this.props;
        const { cicleTime = 75 } = settings;

        for (const key in ANIMATIONS) {
            // const anim = ANIMATIONS[key];
            // const img = new Image();
            // img.src = anim.src;
        }
        this.setState({
            animations: [
                ANIMATIONS[this.state.animationDefault]
                // ANIMATIONS.martelo,
                // ANIMATIONS.ginga,
                // ANIMATIONS.ginga,
                // ANIMATIONS.martelo,
                // ANIMATIONS.bencao,
                // ANIMATIONS.rasteira,
                // ANIMATIONS.ginga,
                // ANIMATIONS.martelo,
                // ANIMATIONS.bencao,
            ],
            animHash: 1,
            frameRate: cicleTime
        })
    }

    componentDidUpdate = (prevProps, { animations, animHash }) => {
        if (animations.length > this.state.animations.length || animHash !== this.state.animHash) {
            this.goAnimate();
        }
    }

    goAnimate = () => {

        const { height } = this.props;
        const koef = STANDART_HEIGHT / height;

        if (!this.state.animations.length) return;

        const { frameRate, gingaFrameRate } = this.state;
        const { key, frames, x, xLeft, xRight, yShift, yShifts, width, missStartFrame } = this.state.animations[0];

        const centerI = (frames / 2) - 1;

        const localXLeft = xLeft || centerI;
        const localXRight = xRight || centerI;

        let i = missStartFrame ? 1 : 0;

        this.setState({ frameY: yShift });

        // gsap.set('.ngg_char_main img', {
        //     translateY: -height * yShift
        // }
        // )

        const interval = (intervalKey) => {
            let shift = 0;

            if (intervalKey !== this.intervalKey) return;

            if (i <= localXLeft) {
                shift = (i / localXLeft) * x;
            }
            if (i > localXLeft && i < localXRight) {
                shift = x;
            }
            if (i >= localXRight) {
                shift = ((frames - 1 - i) / localXRight) * x;
            }


            this.setState({ shiftX: (shift / 100) * (width / koef) });

            // gsap.set('.ngg_char_main', {
            //     translateX: (shift / 100) * (width / koef)
            // }
            // )

            let iShift = 0;

            if (yShifts) {
                const str = yShifts.filter(x => i >= x.innerFrame);
                if (str && str.length) {
                    const { innerFrame, frame } = str[str.length - 1];
                    if (i === innerFrame) {
                        const { key } = str[str.length - 1];
                        const { yShift } = ANIMATIONS[key];


                        this.setState({ frameY: yShift });

                        // gsap.set('.ngg_char_main img', {
                        //     translateY: -height * yShift
                        // }
                        // )
                    }
                    iShift = innerFrame - frame;
                }
            }

            this.setState({ frameX: (i - iShift) });

            // gsap.set('.ngg_char_main img', {
            //     translateX: -(width / koef) * (i - iShift)
            // }
            // )

            i++;

            if (i >= frames) {
                // gsap.set('.ngg_char_main', {
                //     translateX: 0
                // }
                // )

                // gsap.set('.ngg_char_main img', {
                //     translateX: 0
                // }
                // )

                this.setState({ shiftX: 0, frameX: 0 });
                return this.animationDone(this.state.animations[0]);
                // return;
            }

            goTimer(intervalKey);
        }

        const goTimer = (intervalKey) => {
            this.mainTimer = setTimeout(
                () => interval(intervalKey),
                key === this.state.animationDefault ? gingaFrameRate : frameRate
            )
        }

        goTimer(this.intervalKey);

    }

    stopMotion = () => {
        this.mainTimer && clearTimeout(this.mainTimer);
        this.mainTimer = null;
        delete this.mainTimer;
        this.setState({ shiftX: 0, frameX: 0 });
        // gsap.set('.ngg_char_inner', {
        //     translateX: 0
        // }
        // )

        // gsap.set('.ngg_char_inner img', {
        //     translateX: 0
        // }
        // )
    }

    addAnimation = (props) => {
        const { technics, immideatly, hitted, type } = props;
        if (technics && ANIMATIONS[technics]) {
            if (immideatly) {
                this.stopMotion();
                this.intervalKey = (Math.random() * 100000).toFixed();
                this.setState({
                    animations: [ANIMATIONS[technics]],
                    animHash: (Math.random() * 100000).toFixed()
                })
            } else

                this.setState({
                    animations: [...this.state.animations,
                    ANIMATIONS[technics]]
                })
        }

        if (type === 'buffAdded') {
            this.setBuffAnimation(props);
        }

        if (hitted) {
            this.hitted();
        }

    }

    // анимация баффов 
    setBuffAnimation = (props) => {
        const { buff } = props;
        if (!buff || !buff.type) return;

        switch (buff.type) {
            case 'heal': {
                this.ttRef.current && this.ttRef.current.heal();
                break;
            }
            case 'cold': {
                this.ttRef.current && this.ttRef.current.cold();
                break;
            } 
            default: { }
        }

    }

    hitted = () => {
        // gsap.fromTo('.ngg_char_inner', { filter: `drop-shadow( 0px 0px 8px red )` }, {
        //     filter: `drop-shadow( 0px 0px 8px #ff000000 )`,
        //     duration: 1
        // }
        // )
        this.ttRef.current && this.ttRef.current.hitted();
    }

    animationDone = (animation) => {
        const { onAnimationDone } = this.props;
        const { animations, animationDefault } = this.state;
        const res = (animation && onAnimationDone) ? onAnimationDone() : null;

        if (res) {
            // чё то делаем
        }

        const anim = [...animations].slice(1);

        if (anim && anim.length) {
            this.setState({
                animations: anim
            })
        } else {
            this.setState({
                animations: [{ ...ANIMATIONS[animationDefault], missStartFrame: true }],
                animHash: (Math.random() * 100000).toFixed()
            })
        }
    }

    render() {

        const { arena } = this.props;
        const { height, top, left, zIndex } = this.props;

        const {
            frameX,
            frameY,
            shiftX
        } = this.state;

        return <TextureCropper
            width={arena.width}
            height={arena.height}
            zIndex={zIndex}
            textureUrl={`/../images/ver2/snowman/clips/all.png`}

            ref={this.ttRef}

            spriteHeight={height}
            spriteTop={top - height}
            spriteLeft={left + shiftX}

            HtoW={144 / 200}
            allFramesX={10}
            allFramesY={ALL_Y_FRAMES}

            frameX={frameX}
            frameY={frameY}

        />

        // return <div className='ngg_char_main' style={{ width, height, top, left, zIndex }} onClick={() => this.hitted({ technics: 'martelo' })}>
        //     <div className='ngg_char_inner' style={{ width, height }}>
        //         {/* {!!src && <img src={src} />} */}
        //         {<img src={URL_ADD('all')} style={{ height: ALL_HEIGHT / koef }} />}
        //     </div>
        // </div>
    }

}